import Vue from 'vue'
import VueRouter from 'vue-router'

// Import component
import Loading from 'vue-loading-overlay/';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(Loading);
// Init plugin
Vue.use(VueRouter);

const routes = [
  {
    path:'/',
    component:()=>import('../views/doc')
  }
];

const router = new VueRouter({
  routes
});
export default router
